// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qn_a bib_sn bib_va","ForumSearch__img":"qn_b","ForumSearch__searchAdsAndShoppingAds":"qn_c","ForumSearch__results--empty":"qn_e"};